import { addYears, isBefore } from "date-fns";
import { ProviderContractDatabase } from "../../../types";

export function getContractEndDate(contract: ProviderContractDatabase) {
  if (contract.start_at && contract.duration_of_renewal) {
    let endDateComputed = new Date(contract.start_at);
    while (isBefore(endDateComputed, new Date())) {
      endDateComputed = addYears(endDateComputed, contract.duration_of_renewal);
    }
    return endDateComputed;
  }

  return contract.end_at ? new Date(contract.end_at) : null;
}
